module.exports = __webpack_public_path__ + "static/media/Avatars_Female-15.eb6b5a73.png";